






import Vue, { PropType } from 'vue';
import { IconName } from './Icon.types';

export default Vue.extend({
  name: 'Icon',
  props: {
    name: {
      type: String as unknown as PropType<IconName>,
    },
    size: Number,
    spin: Boolean,
    badge: Boolean,
    badgeText: String,
  },
});
